import { defineMeta } from '@/registry/types';

export const progressMeta = defineMeta({
  name: 'Progress',
  level: 'molecule',
  category: 'feedback',
  classification: 'themed-mui',
  description: 'Linear and circular progress indicators. Themed MUI Progress.',
  baseLibrary: '@mui/material',
  muiEquivalent: 'LinearProgress / CircularProgress',
  muiDocs: 'https://mui.com/material-ui/react-progress/',
  a2uiEquivalent: 'ProgressBar / Spinner',
  importPath: '@/molecules/Progress',
  optionalProps: ['variant', 'value', 'color', 'size'],
  supportedStates: ['indeterminate', 'determinate'],
  designTokens: ['colors'],
  accessibility: ['Determinate progress exposes aria-valuenow; provide a label for context.'],
  usageExamples: ['<LinearProgress variant="determinate" value={64} />'],
  antiPatterns: ['Do not use indeterminate progress when percentage is known.'],
  llmSafe: true,
  whenToUse: ['Loading, uploads, scans in progress'],
  whenNotToUse: ['Skeleton content (use Skeleton)'],
});

export default progressMeta;
